import React from 'react';

const Recent = () => {
  const stories = [
    {
      title: "Website Hosting for a Corporate Firm",
      results: [
        "Upgraded server performance for 10x faster loading speeds",
        "Implemented daily backups & data recovery solutions",
        "Ensured 99.9% uptime with zero downtime issues"
      ],
      cta: "Get a High-Performance Hosting Solution Today!"
    },
    {
      title: "eCommerce Hosting & Security Setup",
      results: [
        "Secured an online store with SSL & advanced firewall protection",
        "Implemented automated order & transaction email hosting",
        "Optimized website speed for seamless shopping experiences"
      ],
      cta: "Keep Your Online Store Fast & Secure!"
    },
    {
      title: "Business Email Hosting for a Startup",
      results: [
        "Set up customized business email addresses",
        "Integrated email hosting with Google Workspace & Outlook",
        "Provided anti-spam & security encryption for business emails"
      ],
      cta: "Make Your Business Look Professional with Custom Emails!"
    }
  ];

  return (
    <section className="bg-black text-white py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-8">
            Recent Hosting <span className="text-yellow-500">Success Stories</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            See how our hosting solutions have helped businesses boost performance, enhance security, and improve their online presence.
          </p>
        </div>

        {/* Success Stories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <div 
              key={index}
              className="bg-neutral-900 rounded-2xl border border-neutral-800 overflow-hidden transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-xl"
            >
              {/* Card Header */}
              <div className="pt-6 px-6 pb-4 bg-gradient-to-br from-neutral-800 to-neutral-900 border-b border-neutral-700">
                <h3 className="text-xl font-bold text-white mb-2">{story.title}</h3>
                <div className="w-12 h-1 bg-yellow-500 rounded-full"></div>
              </div>
              
              {/* Card Body */}
              <div className="p-6">
                <ul className="space-y-4 mb-6">
                  {story.results.map((result, idx) => (
                    <li key={idx} className="flex items-start">
                      <div className="text-yellow-500 mr-3 mt-1 flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className="text-gray-300">{result}</span>
                    </li>
                  ))}
                </ul>
                
                {/* CTA Button */}
                <div className="mt-8">
                  <a 
                    href="/contact-us" 
                    className="block w-full text-center py-3 px-4 bg-yellow-500 hover:bg-yellow-600 transition-colors duration-300 text-black font-semibold rounded-lg"
                  >
                    {story.cta}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recent;